import { render, staticRenderFns } from "./cis-prices.vue?vue&type=template&id=822dbd1c"
import script from "./cis-prices.vue?vue&type=script&lang=js"
export * from "./cis-prices.vue?vue&type=script&lang=js"
import style0 from "./cis-prices.vue?vue&type=style&index=0&id=822dbd1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports